// Incentive feature color palette
// Centralized here for easy maintenance and future theme migration

import { SHIFT_CONFIG_COLORS } from "@/shared/components/KPICard";

// --- Color pair type ---
export type ColorPair = { bg: string; text: string };

// --- 6-zone color lookup (uses same palette as KPICard) ---

export interface SixZoneThresholds {
	Red: number;
	Orange: number;
	Yellow: number;
	GreenSoft: number;
	GreenNormal: number;
	GreenHard: number;
}

export const DEFAULT_INCENTIVE_THRESHOLDS: SixZoneThresholds = {
	Red: 0,
	Orange: 40,
	Yellow: 60,
	GreenSoft: 75,
	GreenNormal: 85,
	GreenHard: 95,
};

// --- Text colors ---
export const TEXT = {
	primary: "#333", // dark gray
	secondary: "#555", // medium gray
	tertiary: "#666", // medium-light gray
	disabled: "#aaa", // light gray
	muted: "#9e9e9e", // muted gray
	inProgress: "#1565c0", // blue
	warning: "#f57c00", // orange accent
	white: "#fff", // white
} as const;

export const GRAY_COLOR: ColorPair = { bg: "#e0e0e0", text: "#757575" };

const ZONE_COLORS: ColorPair[] = [
	{ bg: SHIFT_CONFIG_COLORS.greenHard, text: TEXT.white },
	{ bg: SHIFT_CONFIG_COLORS.greenNormal, text: TEXT.white },
	{ bg: SHIFT_CONFIG_COLORS.greenSoft, text: TEXT.white },
	{ bg: SHIFT_CONFIG_COLORS.yellow, text: TEXT.primary },
	{ bg: SHIFT_CONFIG_COLORS.orange, text: TEXT.primary },
	{ bg: SHIFT_CONFIG_COLORS.red, text: TEXT.white },
];

export const getZoneColor = (
	value: number | null,
	t: SixZoneThresholds,
): ColorPair => {
	if (value == null) return GRAY_COLOR;
	if (value >= t.GreenHard) return ZONE_COLORS[0];
	if (value >= t.GreenNormal) return ZONE_COLORS[1];
	if (value >= t.GreenSoft) return ZONE_COLORS[2];
	if (value >= t.Yellow) return ZONE_COLORS[3];
	if (value >= t.Orange) return ZONE_COLORS[4];
	return ZONE_COLORS[5];
};

// --- Row tint backgrounds (Daily Summary) ---
export const ROW_TINTS = {
	override: "#fff4cc", // soft yellow
	current: "#e3f2fd", // pale blue
	total: "#f5f5f5", // light gray
} as const;

// --- Surface colors ---
export const SURFACE = {
	border: "#e0e0e0", // light gray
	borderLight: "#ccc", // lighter gray
	background: "#fafafa", // off-white
	paper: "#fff", // white surface
	overlay: "rgba(255,255,255,0.6)", // translucent white overlay
} as const;

export const CHART = {
	target: "#42A5F5", // chart target blue
} as const;
